import styled from 'styled-components';
import { styles } from '../constants/styles.js';
import { px2rem } from '../utils/helpers/style.js';
import { boxStyles } from '../Box/styles.js';
import { boxPropExclusions } from '../Box/props.js';

var wrapper = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-vr71l7-0"
})(["user-select:none;-webkit-tap-highlight-color:transparent;position:relative;width:", ";height:", ";display:flex;align-items:center;:focus-visible{box-shadow:0 0 0 4px ", ";outline:2px solid ", ";outline-offset:0;}", ""], function (props) {
  return props.width;
}, function (props) {
  return px2rem(props.theme.linearProgress.web.height);
}, function (p) {
  return p.theme.tokens.focus.primary;
}, function (p) {
  return p.theme.tokens.focus.secondary;
}, boxStyles);
var bar = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__bar",
  componentId: "sc-vr71l7-1"
})(["user-select:none;-webkit-tap-highlight-color:transparent;position:absolute;background-color:", ";border-radius:", ";height:", ";transition:width ", ";"], function (props) {
  return props.color;
}, function (props) {
  return px2rem(props.theme.linearProgress.web.borders.radius);
}, function (props) {
  return px2rem(props.theme.linearProgress.web.height);
}, styles.transition.timing.faster);

export { bar, wrapper };
